<template>
  <div class="container-resizable" style="background-color: #F1F1F1;">
      <div class="p-grid">
          <div class="p-md-2"></div>
          <div class="p-md-8 container-data">
            <h2 class="p-text-center">{{$t("messages.howToBePartOfOurAssociates")}}</h2>
            <p>{{$t("messages.howToBePartOfOurAssociatesDescription")}}</p>          
            <hr class="p-mt-6"/>
            <h2 class="p-text-center" style="margin-top: 60px;">{{$t("messages.benefits")}}</h2>
            <ul style="margin-bottom: 50px;">
                <li>{{$t("messages.line1")}}</li>
                <li>{{$t("messages.line2")}}</li>
                <li>{{$t("messages.line3")}}</li>
                <li>{{$t("messages.line4")}}</li>
                <li>{{$t("messages.line5")}}</li>
                <li>{{$t("messages.line6")}}</li>
            </ul>            
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name:"ComoSerParte"
}
</script>

<style lang="scss" scoped>
.container-resizable {  
  justify-content: center;  
  background-color: #FFFFFF;
}
.container-data{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-left: 30px;
}
.container-data h2{
    color: #083078;
    font-size: 40px;
    font-weight: bolder;
}
.container-data p{
    color: #083078;
    font-size: 25px;
}
.container-image{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}
ul{
    font-size: 20px;
    li{
        margin-top: 20px;
    }
}
@media screen and (max-width: 1540px) {
    .container-resizable {  
        padding: 30px 10px;
    }
    .container-data h2{
        font-size: 40px;
    }
    .container-data p{
        font-size: 20px;
    }
}
@media screen and (max-width: 955px) {
    .container-data h2{
        margin-top: 30px;
    }
    .container-image{
        justify-content: center;
        width: 100%;
        img {
            width: 100%;
            margin: 0px auto;
        }
    }
    .container-data {
        padding: 10px;
    }
}
</style>